export enum GRID_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum GRID_SIZE_ORDER {
  small = 1,
  medium,
  large,
}

export enum CUSTOM_FIELDS {
  LAYOUT_L = 'layoutL',
  LAYOUT_M = 'layoutM',
}

export enum FILTER_OPTIONS {
  FAVORITES = 'favorites',
  WAITLIST = 'waitlist',
}

export enum LAYOUT_M_OPTIONS {
  COLUMN_1 = 'column_1',
  COLUMN_1_LEFT_MARGIN = 'column_1_left_margin',
  COLUMN_1_RIGHT_MARGIN = 'column_1_right_margin',
  COLUMN_2 = 'column_2',
}

export enum LAYOUT_L_OPTIONS {
  p25 = '25%',
  p50 = '50%',
  p75 = '75%',
  p100 = '100%',
}

export const ARTWORKS_LIMIT = 24;

export const STORE_FRONT_KEY = 'SHOP_TOKEN';

export const DYNAMIC_DATA = [
  'unframedHeight',
  'unframedWidth',
  'unframedDepth',
  'framedDepth',
  'framedHeight',
  'framedWidth',
  'description',
  'price',
  'inventoryLevel',
  'isFramed',
  'showSpecs',
  'specsDescription',
  'seo',
  'images',
  'urlStandard',
];

export const ARTWORKS_PAGE_PREFIX = 'artworks-page-';
export const HIDDEN_BOTTOM = 'artworks-hidden-bottom';

export enum ePLP_VARIANT {
  artworks = 'artworks',
  trade = 'trade',
  groupings = 'groupings',
}
